import AppMenu from "./AppMenu";
import Logo from "./Logo";

function TopBar({ auth, onLogout, page, setPage }) {
  const displayName = auth?.user?.display_name || "Profil";
  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return (
    <header className="topbar">
      <Logo compact onClick={() => setPage("search")} />
      <AppMenu auth={auth} page={page} setPage={setPage} compact />
      {auth ? (
        <div className="account-menu" aria-label="Konto menu">
          <button
            className="account-chip"
            onClick={() => setPage("profile")}
            type="button"
            aria-label={`Profil for ${displayName}`}
          >
            <span>{initials || "P"}</span>
            {displayName}
          </button>
          <button className="secondary-action" onClick={onLogout} type="button">
            Log ud
          </button>
        </div>
      ) : (
        <div className="account-menu">
          <button className="secondary-action" onClick={() => setPage("login")} type="button">
            Log ind
          </button>
        </div>
      )}
    </header>
  );
}

export default TopBar;
